<!--
검수시요청사항 라벨 컴포넌트 > 기본 템플릿 (배송조회 상품리스트에서 사용되는 라벨)
---------------------------------------

-->
<template>
    <div class="uk-inline uk-position-relative">
        <!-- 라벨 -->
        <a class="uk-link-reset" :href="'/prods/'+this.prodId+'#check-request-header'" target="_blank">
            <span class="uk-label uk-label-primary" @mouseenter="openView" @mouseleave="closeView">
                검수요청사항
            </span>
        </a>

        <!-- 팝업 -->
        <div class="popup" v-show="viewDisplay">
            <!-- 대기 -->
            <div v-show="this.loadState === 'unload'">
                준비중
            </div>

            <!-- 로딩화면 -->
            <div v-show="this.loadState === 'loading'">
                <loading-icon
                    class="uk-text-middle"
                    bg-color="#ccc"
                    fore-color="#333"
                ></loading-icon>
                loading...
            </div>

            <!-- 실제 요청사항 표시 -->
            <div v-show="this.loadState === 'loaded'">
                <div
                    class="request"
                    v-for="req in this.checkRequests"
                    :key="req.id"
                >
                    {{ req.request }}
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Base from './base.vue';

    export default {
        extends: Base,
        components: {
            'loading-icon': require('../../common/loading-icon.vue').default,
        },
    }
</script>

<style lang="scss" scoped>
    // 팝업
    .popup {
        position: absolute;
        bottom: 20px;
        transform: translateX(-50%);
        width: 300px;

        padding: 10px;
        background-color: rgba(0,0,0,0.8);
        border: 1px solid #666;
        color: #fff;
        font-size: 0.875rem;


        // 요청사항
        .request {
            margin-top: 10px;
            &:first-child {
                margin-top: 0;
            }
        }
    }
</style>